import { render, staticRenderFns } from "./cert-event.vue?vue&type=template&id=850fdf96&"
import script from "./cert-event.vue?vue&type=script&lang=js&"
export * from "./cert-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports